import React from 'react';
import AppPage from '@components/app/AppPage';
import AppLayout from '@components/layout/AppLayout';
import PageHeader from '@components/header/PageHeader';
import Footer from './Footer';
import { AppProps } from './types';

export default function AppPageLayout({ children, ...appPageProps }: React.PropsWithChildren<AppProps>): JSX.Element {
  return (
    <AppPage {...appPageProps}>
      <AppLayout header={<PageHeader />} footer={<Footer />}>
        {children}
      </AppLayout>
    </AppPage>
  );
}
